import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection } from 'lexical';
import { forwardRef, useEffect, useState } from 'react';

import { TextLinkWidget } from '~components/generic/editable-field/components/TextLinkWidget/TextLinkWidget';
import ToolbarPlugin from '~components/generic/editable-field/plugins/ToolbarPlugin';
import styles from '../styles.css';

export type FloatingMenuCoords = { x: number; y: number } | undefined;

type FloatingMenuProps = {
  editor: ReturnType<typeof useLexicalComposerContext>[0];
  coords: FloatingMenuCoords;
  calculatePosition: () => void;
  includedControls?: string[];
};

export const FloatingMenu = forwardRef<HTMLDivElement, FloatingMenuProps>(function FloatingMenu(props, ref) {
  const { editor, coords, calculatePosition, includedControls } = props;
  const [showTextLinkWidget, setShowTextLinkWidget] = useState(false);

  const shouldShow = coords !== undefined;

  useEffect(() => {
    const unregisterListener = editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return;
      });
    });
    return unregisterListener;
  }, [editor]);

  const handleOpenTextLinkWidget = () => {
    setShowTextLinkWidget(true);
    calculatePosition();
  };

  const handleCloseTextLinkWidget = () => {
    setShowTextLinkWidget(false);
    calculatePosition();
  };

  return (
    <div
      ref={ref}
      className={styles.toolbarContainer}
      aria-hidden={!shouldShow}
      style={{
        position: 'absolute',
        top: coords?.y,
        left: coords?.x,
        visibility: shouldShow ? 'visible' : 'hidden',
        opacity: shouldShow ? 1 : 0,
      }}
    >
      {showTextLinkWidget ? (
        <TextLinkWidget closeToolbar={handleCloseTextLinkWidget} />
      ) : (
        <ToolbarPlugin includedControls={includedControls} onOpenTextLinkWidget={handleOpenTextLinkWidget} />
      )}
    </div>
  );
});
